var Handlebars = require("handlebars")
var Flickity = require("flickity")
var panzoom = require("panzoom")
var zoomInstance

window.addEventListener("load", (event) => {
  const softgoodFullscreen = document.querySelector(".gear-detail-hero")
  const is_mobile = $(window).width() >= 1023 ? false : true

  if ($(".gear-detail-hero .videoBG")) {
    const videoBgID = $(".gear-detail-hero .videoBG").attr("id")
    const youtubeID = $(".gear-detail-hero .videoBG").attr("data-youtube-id")
    const vimeoID = $(".gear-detail-hero .videoBG").attr("data-vimeo-id")
    const youkuID = $(".gear-detail-hero .videoBG").attr("data-youku-id")

    if (youtubeID) {
      youtubePlaySoftgoodHero(youtubeID, videoBgID)
    }
    if (vimeoID) {
      vimeoPlaySoftgoodHero(vimeoID, videoBgID)
    }
    if (youkuID) {
      youkuPlaySoftgoodHero(youkuID, videoBgID)
    }
  }

  function youtubePlaySoftgoodHero(youtubeID, videoBgID) {
    let ifCompletedOnce = false
    player = new YT.Player(videoBgID, {
      height: "100%",
      width: "100%",
      videoId: youtubeID,
      host: "https://www.youtube.com",
      playerVars: {
        autoplay: 1,
        autohide: 1,
        disablekb: 1,
        controls: 0,
        showinfo: 0,
        modestbranding: 1,
        loop: 0,
        fs: 0,
        rel: 0,
        enablejsapi: 1,
        playlist: youtubeID,
      },
      events: {
        onReady: function (e) {
          track("Video", "Loaded")
          e.target.mute()
          e.target.playVideo()
        },
        onStateChange: function (e) {
          if (e.data === YT.PlayerState.PLAYING) {
            document.getElementById(videoBgID).classList.add("loaded")
            track("Video", "Played")
          }
          if (e.data === YT.PlayerState.PAUSED) {
            let currentTime = e.target.getCurrentTime()
            let duration = e.target.getDuration()
            var completionPercentage = Math.round((currentTime / duration) * 100)
            track("Video", "Paused")
            if (!ifCompletedOnce) {
              track("Video", "Watched " + completionPercentage + "%")
            }
          }
          if (e.data === YT.PlayerState.ENDED) {
            track("Video", "Watched 100%")
            ifCompletedOnce = true
            player.seekTo(0)
          }
        },
      },
    })
  }

  function vimeoPlaySoftgoodHero(vimeoID, videoBgID) {
    let ifCompletedOnce = false
    player = new Player(videoBgID, {
      id: vimeoID,
      muted: 1,
    })
    player.on("play", function (e) {
      document.getElementById(videoBgID).firstChild.classList.add("loaded")
      track("Video", "Played")
    })
    player.on("pause", function (e) {
      var completionPercentage = Math.round(e.percent * 100)
      if (completionPercentage != 100) {
        track("Video", "Paused")
        if (!ifCompletedOnce) {
          track("Video", "Watched " + completionPercentage + "%")
        }
      }
    })
    player.on("ended", function (e) {
      track("Video", "Watched 100%")
      ifCompletedOnce = true
      player.setCurrentTime(0)
      setTimeout(function () {
        player.play()
      }, 300)
    })
  }

  function youkuPlaySoftgoodHero(youkuID, videoBgID) {
    player = new YKU.Player(videoBgID, {
      client_id: "7a0aef3c0f591880",
      vid: youkuID,
      autoplay: true,
      show_related: false,
      events: {
        onPlayerReady: function () {
          document.getElementById(videoBgID).classList.add("loaded")
        },
      },
    })
  }

  if (softgoodFullscreen) {
    var updateSoftgood
      ; (updateSoftgood = function () {
        hbtSoftgoodCarousel = $("#hbt-softgood-carousel").html()
        Imgtemplate = Handlebars.compile(hbtSoftgoodCarousel)
        $(".softgood-carousel-container").html(Imgtemplate(softgood))
      })()
      ; (function () {
        hbtSoftgoodtColors = $("#hbt-softgood-colors").html()
        Colortemplate = Handlebars.compile(hbtSoftgoodtColors)
        $(".softgood-colors-container").html(Colortemplate(softgood))

        productColorButtons = $('#product-color-buttons').html()
        ProductColorButtonTemplate = Handlebars.compile(productColorButtons)
        $('.softgood-cta').append(ProductColorButtonTemplate(softgood));

      })()
    window.updateSoftgood = updateSoftgood

    var softgoodSlider
    var softgoodThumbnails
    var softgoodColors
    var countColorCell
    var countThumb = 0
    softgoodSliderLoad()

    $(".softgood-carousel-container").on("click", ".thumbnail-image:not(.is-selected)", function () {
      var carouselItemIndex = $(this).attr("data-carousel-item-index")
      softgoodSlider.select(carouselItemIndex)
      if (countThumb > 4 || is_mobile) {
        softgoodThumbnails.select(carouselItemIndex)
      }
    })

    $(".color-option").on("click", function (e) {
      $(".color-option").removeClass("is-active")
      if (countColorCell > 4) {
        softgoodColors.select($(this).index())
      }
      softgoodSlider.destroy()

      if (countThumb > 4) {
        softgoodThumbnails.destroy()
      }
      let softgoodColor = this.dataset.color
      softgood.colors.map((p) => {
        p.colorName === softgoodColor ? (p.active = true) : (p.active = false)
      })

      changeColorButtons(softgoodColor)

      updateSoftgood()
      softgoodSliderLoad()
      $(this).addClass("is-active")
    })

    function changeColorButtons(selectedColor) {
      const buttons = document.querySelectorAll(".e-commerce-btn");
      buttons.forEach(el => {
        el.classList.remove("show-ecommerce-btn");
        el.classList.remove("hide-ecommerce-btn");
      });

      const allColorButtons = document.querySelectorAll(`.e-commerce-btn[data-color="${selectedColor}"]`);

      allColorButtons.forEach(el => {
        el.classList.add('show-ecommerce-btn');
      });
    }

    function softgoodSliderLoad() {
      if ($(".softgood-carousel")) {
        softgoodSlider = new Flickity(".softgood-carousel", {
          prevNextButtons: false,
          pageDots: false,
          draggable: true,
          wrapAround: true,
          pauseAutoPlayOnHover: false,
          adaptiveHeight: false,
          cellSelector: ".softgood-carousel-cell",
          cellAlign: "left",
          contain: false,
          resize: true,
          lazyLoad: true,
          imagesLoaded: true,

          on: {
            lazyLoad: function () {
              $(".softgood-carousel-container, .softgood-colors-cover").css("opacity", "1")
              $(".softgood-fullscreen .group-load").hide()
            },
            dragStart: function () {
              $(".softgood-carousel-cell").css("pointer-events", "none")
            },
            dragEnd: function () {
              $(".softgood-carousel-cell").css("pointer-events", "all")
            },
          },
        })
        countThumb = $(".thumbnail-image").length

        if (countThumb > 4 || is_mobile) {
          softgoodThumbnails = new Flickity(".softgood-thumbnail-container", {
            cellAlign: "right",
            cellSelector: ".thumbnail-image",
            contain: true,
            prevNextButtons: false,
            pageDots: false,
            draggable: countThumb > 4 || is_mobile ? ">4" : false,
            wrapAround: false,
            lazyLoad: false,
            imagesLoaded: true,
            on: {
              staticClick: function (event, pointer, cellElement, cellIndex) {
                const color = cellElement.dataset.color
                if (color) {
                  track('Product', `Colour ${color} Clicked`)
                }
              },
            },
          })
        }
        countColorCell = $(".gear-detail-hero .color-option").length

        softgoodColors = new Flickity(".softgood-colors-container", {
          cellAlign: "left",
          cellSelector: ".color-option",
          contain: true,
          prevNextButtons: false,
          pageDots: false,
          draggable: countColorCell > 4 || is_mobile ? ">4" : false,
          wrapAround: false,
          percentPosition: true,
          setGallerySize: true,
          lazyLoad: false,
        })

        $('.color-option').on('click', function (params) {
          const color = $(this).data('color')
          if (color) {
            track('Product', `Colour ${color} Clicked`)
          }
        })

        trackDetailPageViewed()
      }
    }
  }
})

$(".softgood-carousel-container").on("click", ".softgood-zoom-icon", function () {
  $(".modal-body:has(#zoom-container)").css("overflow", "hidden")
  var zoomImageURL = $(".softgood-carousel-cell.is-selected").attr("data-zoom-image-src")
  $("#zoom-container").html('<img class="d-block" src="' + zoomImageURL + '" />')
  $(".zoom-modal-loader").hide()

  zoomInstance = panzoom(document.querySelector("#zoom-container img"), {
    transformOrigin: {
      x: 0.5,
      y: 0.5,
    },
    bounds: false,
    smoothScroll: true,
    boundsPadding: 0.5,
  })

  $("#shimanoModal").on("click", ".zoom-in", function () {
    zoomInstance.smoothZoom(0, 0, 1.1)
  })

  $("#shimanoModal").on("click", ".zoom-out", function () {
    zoomInstance.smoothZoom(0, 0, 0.8)
  })

  zoomInstance.on("transform", updateZoomValue)

  function updateZoomValue() {
    const { scale } = zoomInstance.getTransform()
    $(".softgood-zoomcontrols #zoom-value").html(Math.trunc(scale * 100))
  }
})

Handlebars.registerHelper("checkZoom", function (mobile, tablet, desktop) {
  if ($(window).width() < 576) {
    return mobile
  }
  if ($(window).width() < 992) {
    return tablet
  }
  return desktop
})

function trackDetailPageViewed() {
  let pageLang = $('html')[0].lang
  let pageTemplate = 'Product Detail'
  let pageTitle = document.title
  let pageURL = window.location.href
  let props = {
    page: { template: pageTemplate, language: pageLang, title: pageTitle, url: pageURL },
  }

  let parts = window.location.pathname.split("/")
  let category
  if (parts.length == 5) {
    category = parts[2][0].toUpperCase() + parts[2].slice(1) + "/" + parts[3][0].toUpperCase() + parts[3].slice(1)
  } else if (parts.length == 4) {
    category = parts[1][0].toUpperCase() + parts[1].slice(1) + "/" + parts[2][0].toUpperCase() + parts[2].slice(1)
  }

  let productId = "CP-" + $("body").attr("data-asset-id")
  let productName = $(".softgood-fullscreen").attr("data-asset-label")
  let variants = $(".softgood-fullscreen").attr("data-variants")
  let ecommerce = {
    detail: {
      products: [
        {
          name: productName,
          id: productId,
          category: category,
          brand: 'Gravel',
          variant: variants
        }],
    },
  }

  track("Product", "Detail Page Viewed", props, null, ecommerce)
}